module.exports = __webpack_public_path__ + "img/fn-b-flower.df075820.png";